import { useMemo } from 'react'

import { AnalyticsQueryDatapointEnum, AnalyticsQueryQueryEnum } from '@infura/packages.api'

import { useDynamicStats1_5_Query } from 'hooks/useStats'

import dayjs from 'lib/dayjs'

export type RequestActivityResponseType = {
  network: string
  method: string
  value: number
  failures: number
  success: number
  '200s': number
  '300s': number
  '400s': number
  '500s': number
  failed_requests: number
  success_requests: number
}
const TEN_SECONDS = 10_000

export const useRequestHealth = (id?: string) => {
  const { endOfDay, startOfDay } = useMemo(() => {
    const now = dayjs().utc()
    const startOfDay = now.startOf('day')
    const endOfDay = now.endOf('day')

    return { endOfDay, startOfDay }
  }, [])

  const { data, isLoading, ...rest } = useDynamicStats1_5_Query({
    config: {
      refreshInterval: TEN_SECONDS
    },
    datapoint: AnalyticsQueryDatapointEnum.COUNT,
    intervals: `${startOfDay.toISOString()}/${endOfDay.toISOString()}`,
    product: 'ethereum',
    projectIds: id ? [id] : [],
    query: AnalyticsQueryQueryEnum.ACTIVITY,
    time: '24h'
  })

  // TODO: Typing for stats data is completely incorrect, need to fix this
  const dataTyped = data?.data[0].result as unknown as Array<RequestActivityResponseType> | undefined

  return {
    data,
    dataTyped,
    isLoading,
    ...rest
  }
}
